import { ACTION_TYPES } from '~/core/constants'

const { SETTINGS } = ACTION_TYPES

const initialState = {
  hideUpcoming: false,
  addons: {
    salesforce: false
  },
  userSettings: {
    allowDesktopLaunch: false,
    allowMeetingSharing: false,
    enabledGiphyIntegration: false,
    enabledOnlyModerator: false,
    enabledSalesforceIntegration: false,
    enabledWaitForMe: false,
    onlyModerator: false,
    showGiphyIntegration: false,
    showRecordingPrompt: false,
    showSalesforceIntegration: false,
    waitForMe: false
  },
  usePersonalRoom: true,
  useNewMeetingsExperience: false,
  hasMeetMetricsAccess: false
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SETTINGS.SET_SCHEDULE_PERSONAL_ROOM: {
      return {
        ...state,
        usePersonalRoom: action.payload
      }
    }
    case SETTINGS.SET_CONFERENCE_SETTINGS: {
      const { schedulePersonalRoom, hideUpcoming } = action.payload
      return {
        ...state,
        hideUpcoming,
        usePersonalRoom: schedulePersonalRoom
      }
    }
    case SETTINGS.SET_ADDONS: {
      return {
        ...state,
        addons: {
          ...state.addons,
          ...action.payload
        }
      }
    }
    case SETTINGS.SET_USER_SETTINGS: {
      return {
        ...state,
        userSettings: {
          ...state.userSettings,
          ...action.payload
        }
      }
    }
    case SETTINGS.SET_NEW_MEETINGS_EXPERIENCE: {
      return {
        ...state,
        useNewMeetingsExperience: action.payload
      }
    }
    case SETTINGS.SET_MEET_METRICS_ACCESS: {
      return {
        ...state,
        hasMeetMetricsAccess: action.payload
      }
    }
    default:
      return state
  }
}

export default reducer
